/**
 * The account pages' addresses (plan D1: `/profile`, `/profile/notifications`,
 * `/profile/settings` on both brands; `/profile/device` where the app mounts it), built from the
 * app's `profileLink.href` so its trailing slash rule carries over.
 */
export type AccountPageId = 'profile' | 'notifications' | 'settings' | 'device'

export function accountHref(profileHref: string, page: AccountPageId = 'profile'): string {
  if (page === 'profile') {
    return profileHref
  }
  return profileHref.endsWith('/') ? `${profileHref}${page}/` : `${profileHref}/${page}`
}

/** The bell's links to the account Notifications page (HeaderAuth `notificationLinks`). */
export function accountNotificationLinks(profileHref: string): { settings: string; all: string } {
  const all = accountHref(profileHref, 'notifications')
  return { all, settings: `${all}#notify-settings` }
}
